module.exports = __webpack_public_path__ + "static/media/AverilOfflineBookJacket.03e4a296.jpg";